import "../index.scss";

import React from "react";
import Moment from "moment";
import _ from "lodash"
class Holidays extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {calendar} = this.props;
        const  calholidays = ((calendar || {}).calendar_holiday || []).map(h => ({date: h.date, holiday: h.holiday}))
        const holidays = _.sortBy(calholidays, 'date')
        return (
            <div class="modal calendar-settings-modal fade bg-overlay" id="holidaysViewModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header border-none pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="text-size18 text-black brndnTxt-m mb0">{`${calendar.calendar} Calendar`}</p>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <a class="text-right text-black mt3" data-dismiss="modal" aria-label="Close">
                                        <span class="mr5">{` ${calendar.isDefault? '':'Back to Calendar Subscriptions'}`}</span>
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body pt20 pb40">
                            <table>
                                <thead>
                                    <tr>
                                        <td>#</td>
                                        <td>Date</td>
                                        <td>Holiday Name</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {holidays.map((h, i) => {
                                        return (
                                            <tr>
                                                <td>{i + 1}</td>
                                                <td>{Moment(h.date).format("DD-MMM YYYY")}</td>
                                                <td>{h.holiday}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Holidays.defaultProps = {
    holidays: []
}

export default Holidays;
